import _range from 'lodash/range';
import { Slider } from '@/components/global';
import Card from './Card';
import useStyles from './styles';

const settings = {
  dots: true,
  autoplay: false,
  autoplaySpeed: 4000,
  lazyLoading: false,
  arrows: false,
  initialSlide: 2,
  touchThreshold: 40,
};

export default function Social() {
  const cls = useStyles();
  return (
    <section className={cls.card}>
      <Slider {...settings} className={cls.slider}>
        {_range(4).map((i, idx) => (
          <Card item key={idx} />
        ))}
      </Slider>
    </section>
  );
}
